import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import jsPDF, { jsPDFOptions } from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

import domToImage from 'dom-to-image';
import moment from 'moment';



@Component({
  selector: 'app-payment-book',
  templateUrl: './payment-book.component.html',
  styleUrls: ['./payment-book.component.scss']
})
export class PaymentBookComponent implements OnInit {
  amortization: any;
  contractId:any;
  payExpDays = 15;
  solicitante: any;

  pages:any;
  pdf:any;

  Arr = Array;
  // @ViewChild('paySlip', { static: false }) public paySlip: ElementRef;
  @ViewChildren('paySlip', { read: ViewContainerRef }) public paySlip: QueryList<ViewContainerRef>;

  constructor(private authService: AuthenticationService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.contractId = this.route.snapshot.paramMap.get("id");
    this.getContract(this.contractId);
  }

  getContract(id:any){
    this.authService.getLoanContracts().then((res:any)=>{
        let data = res.find((x:any) => x.id == id);
        this.solicitante = JSON.parse(data.solicitante)
        console.log(this.solicitante);
        this.amortization = JSON.parse(data.amortization);
        this.amortization = this.amortization.map((x:any) => {
          let date = new Date(x.thisDate);
          date.setDate(date.getDate() + this.payExpDays);
          x.expDate = date;
          x.recargo = x.thisPaymentAmount * .05;
          x.recargoPaymentAmount = x.thisPaymentAmount + x.recargo;
          return x;
        })

        let i = 1;
        let pages:any = [];
        let pages2:any = []
        for(let amorti of this.amortization){
          console.log(i%4);
          pages.push(amorti);
          if(i%4 == 0){
            pages2.push({slips: pages});
            pages= [];
          }
          i++;
        }
        console.log(pages2);

        this.pages = pages2;
        
        console.log(this.pages);
        console.log(this.amortization);
        this.setPDF();
      })
  }

  setPDF(){
    let orientation = 'p';
    let imageUnit = 'pt';
    let jsPdfOptions:any = {
      orientation: orientation,
      unit: imageUnit,
      format: [2750, 2150]
      };
    this.pdf = new jsPDF(jsPdfOptions);
    this.pdf.setFontSize(28);
    this.pdf.setTextColor('#2585fe');
    this.pdf.text('Contrato# ' + this.contractId ? 'contrato#' + this.contractId.toUpperCase() : 'Untitled dashboard'.toUpperCase(), 25, 75);
    this.pdf.setFontSize(24);
    this.pdf.setTextColor('#131523');
    this.pdf.text('Generated Date: ' + moment().format('ll'), 25, 115);
    
  }
  
async downloadAsPDF(){
  let i = 0;
  this.paySlip.map(async (x:any)=>{
    console.log(x);
    x = x.element;
    const width = x.nativeElement.clientWidth + 1500;
    const height = x.nativeElement.clientHeight + 1500;
    domToImage.toPng(x.nativeElement, {
      // quality: 0.99,
      width: width,
      height: height,
      style: {
        transform: 'scale(2)',
        transformOrigin: 'top left'
      }
    }).then(result => {
      this.pdf.addImage(result, 'PNG', 25, 185, width, height, 'FAST');
      i++;
      if(i < this.pages.length){
        this.pdf.addPage();
      } else{
        this.pdf.save(this.contractId+'-pay'+ '.pdf');
      }
      
      })
      .catch(error => {
      });
  })
  
}


exportAllToPDF(pages: HTMLElement) {
  // console.log(pages);
  // const doc = new jsPDF();
  let options: jsPDFOptions = {
    orientation: 'p',
    unit: 'cm',
    format: [100,400]
    
    
  }
  const doc = new jsPDF();

  doc.html(pages, {
    callback: (doc: jsPDF) => {
      doc.deletePage(doc.getNumberOfPages());
      doc.save(this.contractId+'-paySlips.pdf');
    }
  });
}

}
